const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/actions/imagesActions.ts';
import { KisApiAction, kisapiActionTypes } from '@cistec/common_web/defs/actionTypes';
import { KISAPI as API } from '@cistec/common_web/middleware/kisapi';
import { apiGetImageAttachment } from '@cistec/common_web/actions/kisapi/images';

export const atLoadPDFRecord = kisapiActionTypes('COMMON_LOAD_PDFRECORD');

export function actionLoadPDFRecord(sender: string, icode: string) {
    return {
        type: atLoadPDFRecord.combined,
        [API]: apiGetImageAttachment(icode, sender),
        meta: { icode, sender },
    };
}

export type LoadPDFRecordAction = KisApiAction<typeof actionLoadPDFRecord>;
